import {Item} from '../../../../../core';
import {DataTable} from '../../data-table.interface';

const iconsOfActionsList = [
  {
    icon: 'exchange',
    tooltip: 'Cambiar'
  },
  {
    icon: 'return',
    tooltip: 'Devolver'
  }
];
export const exchangeManagementDetail = {
  searchText: '',
  addText: '',
  checkbox: true,
  filter: false,
  filterDefault: '',
  disabled: false,
  partialField: '',
  iconsOfActions: iconsOfActionsList,
  show: 'No existe items o no está autorizado para verlos',
  hasDisabledCheckBoxItem: (item: any) => {
      return item.returnedQuantity == item.originalCreationQuantity;
  },
  columns: [
    {
      title: 'SKU',
      name: 'skuCode',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: Item) => element.sku
    },
    {
      title: 'Descripción',
      name: 'description',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: Item) => element.name.replace('�', '')
    },
    {
      title: 'LPN',
      name: 'lpnNumber',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: Item) => element.lpn
    },
    {
      title: 'Cant. Total',
      name: 'quantity',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Item) => element.originalCreationQuantity
    },
    {
      title: 'Cant. Pendiente de entrega',
      name: 'pendingQuantity',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Item) => element.pendingQuantity
    },
    {
      title: 'Cant. Entregada',
      name: 'processedQuantity',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Item) => element.processedQuantity
    },
    {
      title: 'Cant. Cancelada',
      name: 'canceledQuantity',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Item) => element.canceledQuantity
    },
    {
      title: 'Cant. Devuelta',
      name: 'returnedQuantity',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Item) => element.returnedQuantity
    },
    {
      title: 'Estado',
      name: 'status',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: Item) => element.state.toUpperCase()
    },
    {
      title: 'Ubicación',
      name: 'location',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Item) => element.location
    },
    {
      title: 'Imagen',
      type: 'button',
      name: 'image',
      editable: false,
      checkAll: false,
      class: 'left',
      value: () => {
        return {
          icon: 'photo',
          svg: true,
          tooltip: 'Ver detalles del producto',
          class: 'recordColumn icon-table'
        };
      }
    }
  ]
};
